<template>
    <div id="wrapper" class="dark-bg">
        <EagerBrandFontWarmup />
        <!--
        overflow-x-hidden prevents full-bleed (e.g. 100vw) from causing horizontal scroll;
        overflow-y-visible avoids a second vertical scrollbar and keeps sticky elements working relative to the main scroll
        -->
        <UMain ref="mainScrollRootRef" class="h-full overflow-x-hidden overflow-y-auto">
            <!-- App Header -->
            <Navigation
                :title="'CRANE'"
                :show-menu="true"
                layout="centered"
                :use-offset="navigationUseOffset"
                @redirect-to-my-account="redirectToMyAccount"
                @redirect-to-home-page="redirectToHomePage"
            />
            <slot />
            <!-- <Footer /> -->
            <CraneAddressSuggestionDrawer />
            <AuthFlow />
            <LazyCustomModal :open="!!showErrorRecoveryDialog" :title="`Error recovery`">
                <template #body>
                    <ErrorRecovery />
                </template>
            </LazyCustomModal>
        </UMain>
    </div>
</template>

<script setup lang="ts">
// imports
import { storeToRefs } from 'pinia'
import EagerBrandFontWarmup from '~~/layers/base/components/shared/EagerBrandFontWarmup.vue'
import CraneAddressSuggestionDrawer from '~~/layers/base/components/crane/AddressSuggestionDrawer.vue'
import Navigation from '~~/apps/web/components/shared/Navigation/index.vue'
// import Footer from '~~/layers/base/components/shared/Footer.vue'
import { useMainScrollRoot } from '~~/layers/base/composables/useMainScrollRoot'

const mainScrollRootRef = ref<HTMLElement | { $el: HTMLElement } | null>(null)
useMainScrollRoot(mainScrollRootRef)

useSeoMeta({
    ogImage: 'https://landing-template.nuxt.dev/social-card.png',
    twitterImage: 'https://landing-template.nuxt.dev/social-card.png',
    twitterCard: 'summary_large_image',
})
const runtimeConfig = useRuntimeConfig() as {
    public?: {
        storefrontUrl?: string
    }
}

const storefrontUrl = runtimeConfig.public?.storefrontUrl
// pinia store instances
const authStore = useCustomerAuthAccsStore()
const customerStore = useCustomerStore()
const errorRecoveryStore = useErrorRecoveryStore()

// STORE REACTIVE VARIABLES

const showErrorRecoveryDialog = computed(() => errorRecoveryStore.isErrorRecoveryOpen)
const { customerAuth } = storeToRefs(authStore)

const { getCustomer } = customerStore

if (customerAuth?.value) {
    getCustomer()
}
useDatadogUser()
const redirectToMyAccount = () => {
    window.location.href = `${storefrontUrl}/me/account-dashboard`
}
const redirectToHomePage = () => {
    window.location.href = `${storefrontUrl}`
}

// Access page meta for navigation useOffset prop
// If page meta has useOffset set, only apply it on desktop
// Otherwise, default to false (no offset by default)
const route = useRoute()
const { isDesktop } = useIsDesktop()
const navigationUseOffset = computed(() => {
    const pageHasUseOffsetMeta = route.meta.useOffset !== undefined
    if (pageHasUseOffsetMeta) {
        // Page explicitly set useOffset - only apply on desktop
        return route.meta.useOffset === true && isDesktop.value
    }
    // Default behavior: no offset
    return false
})
</script>
